import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmationService, ConfirmEventType, MenuItem, MessageService} from 'primeng/api';
import {UserMgmtService} from '../@shared/new-services/user-mgmt.service';
import {Platform} from '@angular/cdk/platform';
import {Menu} from 'primeng/menu';
import {Paginator} from 'primeng/paginator';
import {Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DatePipe} from '@angular/common';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-user-mgmt',
    templateUrl: './user-mgmt.component.html',
    styleUrls: ['./user-mgmt.component.scss']
})
export class UserMgmtComponent implements OnInit {

    breadcrumbMenuModel: MenuItem[] = [];
    home: MenuItem = {icon: 'pi pi-home', routerLink: '/booking-summary'};
    filteredUsers: any;
    userOptionMenu: MenuItem[] = [];
    @ViewChild('userMenu') menuItem: Menu;
    @ViewChild('userPagination') userPagination: Paginator;
    selectedUser: any;
    isLoading = false;
    identifier = '';
    displayUpdateUserPassword: boolean;
    updatedPassword: any;
    updatedConfirmPassword: any;
    userBasicDetailsForm: FormGroup;
    displayUpdateUserDetails: boolean;
    roles: any;
    isFileDownloading: boolean;

    constructor(private userMgmtService: UserMgmtService,
                private messageService: MessageService,
                public platform: Platform,
                private router: Router,
                private confirmationService: ConfirmationService) {
    }

    ngOnInit(): void {
        this.breadcrumbMenuModel = [
            {label: ' User Management'},
        ];
        this.getFilteredUsers();
        this.getRoles();
        this.createUserBasicDetailsForm();
    }


    getFilteredUsers(identifier = '', page = 0, size = 10) {
        this.isLoading = true;
        this.selectedUser = null;
        this.userMgmtService.getFilteredUsers(identifier, page, size)
            .subscribe(
                (users) => {
                    this.isLoading = false;
                    this.filteredUsers = users;
                    this.userOptionMenu = [
                        {
                            label: 'Edit User',
                            visible: true,
                            command: () => {
                                this.navigateToEditUser(this.selectedUser);
                            }
                        },
                        {
                            label: 'Reset Password',
                            visible: true,
                            command: () => {
                                this.showUserPasswordDialog();
                            }
                        },
                        {
                            label: 'Update Basic Details',
                            visible: true,
                            command: () => {
                                this.showUserBasicDetailsDialog();
                            }
                        }
                    ];
                }, (error) => {
                    this.filteredUsers = null;
                    this.isLoading = false;
                    this.presentToastMessage('error', error?.message ? error?.message : error);
                }
            );
    }

    presentToastMessage(severity, detail) {
        this.messageService
            .add(
                {
                    severity,
                    summary: 'User Management Message',
                    key: 'user-mgmt-message',
                    detail,
                }
            );
    }

    handleUserOptionMenu(event: Event, user) {
        this.menuItem.toggle(event);
        this.selectedUser = user;
    }

    handleUserSearch(event: any) {
        const identifier = event?.target?.value;
        this.getFilteredUsers(identifier);
        this.identifier = identifier;
        this.userPagination.changePage(0);
    }

    handleBlockOrInBlockUser(user: any) {
        this.userMgmtService
            .handleUserAccountStatus(user)
            // tslint:disable-next-line:no-shadowed-variable
            .subscribe((user) => {
                this.presentToastMessage('success', user?.enabled ? 'User: ' + user?.username + ' Activated'
                    : 'User: ' + user?.username + ' Deactivated');
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    paginateFilteredUsers(event: any) {
        this.getFilteredUsers(this.identifier, event?.page, event?.rows);
    }

    navigateToNewUserCreation() {
        this.router
            .navigate(
                ['/', 'manage-user'],
                {
                    queryParams: {
                        mode: 'add'
                    }
                }
            );
    }

    navigateToEditUser(user: any) {
        this.router
            .navigate(
                ['/', 'manage-user'],
                {
                    queryParams: {
                        userId: user?.userId,
                        mode: 'edit'
                    }
                }
            );
    }

    getRoles() {
        this.userMgmtService
            .getRoles()
            .subscribe((roles) => {
                this.roles = roles;
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    showUserPasswordDialog() {
        this.updatedPassword = null;
        this.updatedConfirmPassword = null;
        this.displayUpdateUserPassword = true;
    }

    updateUserPassword() {
        if (this.updatedPassword !== this.updatedConfirmPassword) {
            this.presentToastMessage('info', 'Password not matched, Please check !');
            return;
        }
        const signUpRequest: any = {
            username: this.selectedUser?.username,
            roles: this.selectedUser?.roles?.map((role) => {
                return role?.name;
            }),
            email: this.selectedUser?.email,
            password: this.updatedPassword,
        };
        this.userMgmtService
            .handleUpdatePassword(signUpRequest)
            .subscribe((x) => {
                this.displayUpdateUserPassword = false;
                this.presentToastMessage('success', 'User: ' + signUpRequest?.username + 'Password Changed');
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    onCancelOfUpdatePassword() {
        this.displayUpdateUserPassword = false;
        this.selectedUser = null;
        this.updatedPassword = null;
        this.updatedConfirmPassword = null;
    }

    showUserBasicDetailsDialog() {
        this.displayUpdateUserDetails = true;
        this.createUserBasicDetailsForm();
    }

    onCancelOfUpdateUserBasicDetails() {
        this.displayUpdateUserDetails = false;
    }

    exportExcel(dataContent: any) {
        const exportedBookings = this.exportedColumnsForFileDownload(dataContent);
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(exportedBookings);
            const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']};
            const excelBuffer: any = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            this.saveAsExcelFile(excelBuffer, 'users-listing');
        });
    }

    downloadFiles() {
        console.log('Clicked');
        this.confirmationService.confirm({
            message: 'Select the option to download file.',
            header: 'Download Options',
            icon: 'pi pi-download',
            accept: () => {
                // Download the current page only.
                this.exportExcel(this.filteredUsers?.content);

            },
            reject: (type) => {
                switch (type) {
                    case ConfirmEventType.REJECT:
                        // Download All Pages
                        this.isFileDownloading = true;
                        this.userMgmtService?.getFilteredUsers(this.identifier, 0, 10000,)
                            .subscribe((x) => {
                                this.isFileDownloading = false;
                                this.exportExcel(x?.content);

                            });
                        break;
                    case ConfirmEventType.CANCEL:
                        // Closed dialog box without any options to download.
                        break;
                }
            }
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }

    exportedColumnsForFileDownload(dataContent: any) {
        const datePipe = new DatePipe('en-US');
        const exportedUsers = dataContent?.map((user) => {
            const exportUser = {
                Username: user?.username ? user?.username : '-',
                'First Name': user?.firstName ? user?.firstName : '-',
                'Last Name': user?.lastName ? user?.lastName : '-',
                'User Domains': user?.userDomains.length === 0 ? 'All Domains Assigned' : user.userDomains?.map((x) => {
                    return x.domainName + '( ' + x.domainId + ' )';
                }).join(', '),
                'User Customers': user?.userEntities.length === 0 ? '-' : user.userEntities?.map((x) => {
                    return x.name + '( ' + x.businessEntityId + ' )';
                }).join(', '),
                'Account Status': user?.enabled ? 'Active' : 'Not Active'
            };
            return exportUser;
        });
        return exportedUsers;
    }

    updateUserBasicDetails() {
        const user = this.userBasicDetailsForm.value;
        user.roles = user?.roles?.map((role) => {
            return role?.name;
        });
        this.userMgmtService
            .updateUserBasicDetails(this.selectedUser?.userId, user)
            // tslint:disable-next-line:no-shadowed-variable
            .subscribe((user) => {
                this.displayUpdateUserDetails = false;
                this.presentToastMessage('success', 'Basic Details for User : ' + this.selectedUser?.username + ' Updated !');
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    createUserBasicDetailsForm() {
        this.userBasicDetailsForm = new FormGroup(
            {
                firstName: new FormControl(this.selectedUser?.firstName ? this.selectedUser?.firstName : ''),
                lastName: new FormControl(this.selectedUser?.lastName ? this.selectedUser?.lastName : ''),
                username: new FormControl(this.selectedUser?.username
                    ? this.selectedUser?.username : '', [Validators.email, Validators.required]),
                email: new FormControl(this.selectedUser?.email ? this.selectedUser?.email : ''),
                roles: new FormControl(this.selectedUser?.roles ? this.selectedUser?.roles : ['ROLE_USER'], [Validators.required]),
            }
        );
    }
}
